// extracted by mini-css-extract-plugin
var _1 = "About-jMDVc";
var _2 = "Avatar-lbomR";
var _3 = "AvatarSecond-gOhAs";
var _4 = "Avatars-LRk3W";
var _5 = "Container-iSAOi";
var _6 = "Content-wenPK";
var _7 = "Created-PQcyT";
var _8 = "Details-d3KsB";
var _9 = "ExperienceLink-lOuS7";
var _a = "Footer-TGEIh";
var _b = "GuestName-Ow2li";
var _c = "Header-ywq_H";
var _d = "LocalLink-ZCXXi";
var _e = "Paragraph-_Tio5";
var _f = "Title-C7XQL";
export { _1 as "About", _2 as "Avatar", _3 as "AvatarSecond", _4 as "Avatars", _5 as "Container", _6 as "Content", _7 as "Created", _8 as "Details", _9 as "ExperienceLink", _a as "Footer", _b as "GuestName", _c as "Header", _d as "LocalLink", _e as "Paragraph", _f as "Title" }
